<template>
  <div>
    <div class="search-wrap" style="margin-top: 5px">
      <div class="spacing">
        <el-input size="mini" placeholder="原有人"  clearable v-model="self_where.name" style="width: 200px"></el-input>
      </div>
      <div class="spacing">
        <el-input size="mini" placeholder="调整后人员"  clearable v-model="self_where.to_name" style="width: 200px"></el-input>
      </div>
      <div class="spacing">
        <el-button size="mini" type="primary" @click="search">搜索</el-button>
        <el-button size="mini" @click="showBox()">调整</el-button>
      </div>
    </div>
    <div class="table-wrap" style="width: 100%">
      <el-table :data="pageData.list" style="width: 100%">
        <el-table-column prop="id" label="ID" width="100"></el-table-column>
        <el-table-column prop="name" label="原有人" width="400"></el-table-column>
        <el-table-column prop="to_name" label="调整后人员" width=""></el-table-column>
        <el-table-column prop="master_id" label="流程类型" width=""></el-table-column>
        <el-table-column prop="create_time" label="操作日期" width=""></el-table-column>
        <template>
          <el-table-column label="操作" width="">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" @click="">查看记录</el-button>
            </template>
          </el-table-column>
        </template>
      </el-table>
    </div>

    <div class="pagination-wrap">
      <el-pagination background layout="prev, pager, next" :total="pageData.total*1" :page-size="pageData.pageSize*1" :current-page="pageData.page*1" @current-change="pageChange"></el-pagination>
    </div>

    <!--发起的审批单详情-->
    <el-dialog title="" :visible.sync="dialogVisible" :close-on-click-modal="false" width="1200px">

      <el-descriptions title="" :column="1" border>
        <el-descriptions-item label="原有人" labelStyle="width: 150px">
          <el-select v-model="formData.xsc_user_id" filterable remote :remote-method="getUserList" style="width: 100%">
            <el-option
              v-for="item in userList"
              :key="item.UserID"
              :label="item.ancestor_UserName"
              :value="item.UserID">
            </el-option>
          </el-select>
        </el-descriptions-item>
        <el-descriptions-item label="调整后" labelStyle="width: 150px">
          <el-select v-model="formData.to_xsc_user_id" filterable remote :remote-method="getUserList" style="width: 100%">
            <el-option
              v-for="item in userList"
              :key="item.UserID"
              :label="item.ancestor_UserName"
              :value="item.UserID">
            </el-option>
          </el-select>
        </el-descriptions-item>
        <el-descriptions-item label="流程类型" labelStyle="width: 150px">
          <el-select v-model="formData.master_id" clearable placeholder="请选择" style="width: 100%">
            <el-option
              v-for="item in masterList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>

        </el-descriptions-item>
      </el-descriptions>

<!--      <el-table :data="boxData.stepsData"-->
<!--                border style="width: 100%; margin-top: 20px">-->
<!--        <el-table-column prop="node_name" label="节点名称" width="200"></el-table-column>-->
<!--        <el-table-column  label="审批类型" align="center">-->
<!--          <template slot-scope="scope">-->
<!--            <el-tag effect="dark"  v-if="scope.row.business_type === 3">审批</el-tag>-->
<!--            <el-tag effect="dark" type="warning" v-if="scope.row.business_type === 4">会签</el-tag>-->
<!--            <el-tag effect="dark" type="success" v-if="scope.row.business_type === 5">委托</el-tag>-->
<!--          </template>-->
<!--        </el-table-column>-->
<!--        <el-table-column prop="action_user_name" label="审批人" align="center"></el-table-column>-->
<!--&lt;!&ndash;        <el-table-column label="状态" align="center">&ndash;&gt;-->
<!--&lt;!&ndash;          <template slot-scope="scope">&ndash;&gt;-->
<!--&lt;!&ndash;            <el-tag v-if="scope.row.is_handle === 1" type="success">已操作</el-tag>&ndash;&gt;-->
<!--&lt;!&ndash;            <el-tag v-if="scope.row.is_handle === 0" type="danger">未操作</el-tag>&ndash;&gt;-->
<!--&lt;!&ndash;          </template>&ndash;&gt;-->
<!--&lt;!&ndash;        </el-table-column>&ndash;&gt;-->
<!--        <el-table-column prop="select_action" label="审批结果" align="center">-->
<!--          <template slot-scope="scope">-->
<!--            <el-tag v-if="scope.row.select_action === '同意' " type="success">同意</el-tag>-->
<!--            <el-tag v-if="scope.row.select_action === '拒绝' " type="danger">拒绝</el-tag>-->
<!--          </template>-->
<!--        </el-table-column>-->
<!--        <el-table-column  label="完成时间" align="center">-->
<!--          <template slot-scope="scope" v-if="scope.row.is_handle === 1">-->
<!--            {{  new Date(parseInt(scope.row.handle_time) * 1000).toLocaleString().replace(/\//g, '-') }}-->
<!--          </template>-->
<!--        </el-table-column>-->
<!--        <el-table-column label="操作" width="250" align="center">-->
<!--          <template slot-scope="scope">-->
<!--            <div v-if="scope.row.is_handle === 0-->
<!--                    && scope.row.is_flow_handle === 1-->
<!--                    && boxData.isFlowHandle" class="button-table" @click="flowHandle(scope.row)">审批</div>-->

<!--            <div v-if="scope.row.is_handle === 0-->
<!--                    && boxData.isFlowHandle" class="button-table" @click="editActionUser(scope.row, scope.$index)">修改审批人</div>-->

<!--            <div v-if="scope.row.is_handle === 0-->
<!--                    && boxData.isFlowHandle" class="button-table" @click="sendMsgToActionUser(scope.row)">提醒发送</div>-->
<!--          </template>-->
<!--        </el-table-column>-->
<!--      </el-table>-->

      <div slot="footer" class="dialog-footer">
        <el-button @click="submitForm">确认</el-button>
        <el-button @click="dialogVisible = false">取消</el-button>
      </div>
    </el-dialog>

  </div>

</template>

<script>

import FlowTimeoutLog from "./components/FlowTimeoutLog";
import Http from "./common/Http";
import moment from "moment/moment";
import selectPersonnel from "../Personnel/components/selectPersonnel";

export default {
  name:"FlowAbnormal",
  components: {FlowTimeoutLog, selectPersonnel},
  data () {
    return {
      loading: false,
      dialogVisible:false,
      dialogVisibleApprove:false,
      self_where:{
        process_name: '',
        is_finish: 0,
        task_id:'',
        serial_number:'',
        promoter_user:'',
        current_user:'',
        date_range: [],
      },
      re_load_status:true,
      pageData:{
        list:[],
        total:0,
        pageSize:10,
        page:1
      },
      boxData:{
        instForm:{},
        stepsData:[],
        nodeData:{},
        isFlowHandle : true
      },
      formData: {

      },
      masterList: [],
      userList: [],
    }
  },
  created() {
    this.getList()
    this.getMasterList()
  },
  mounted() {
  },
  methods: {
    search() {
      this.pageData.page = 1
      this.getList()
    },
    pageChange(i) {
      this.pageData.page = i
      this.getList()
    },
    getList() {
      let that = this;
      let param = {
        name: that.self_where.name,
        to_name: that.self_where.to_name,
        page: this.pageData.page,
        page_size: this.pageData.pageSize
      }
      Http.get("flow/FlowProcessSteps/getDeployList",param,res=>{
        if(res.code) {
          that.pageData.list = res.data.data
        }
      })
    },
    getMasterList() {
      const that = this;
      let searchWhere = {page : 1, page_size : 1000};
      Http.get("flow/FlowMaster/getList",searchWhere,res=>{
        if(res.code) {
          that.masterList = res.data.list
        } else {
          that.masterList = {}
        }
      })
    },
    getUserList(query) {
      const that = this;
      Http.get("hr/User/getUserListAll", {name: query},res=>{
        if(res.code == 0) {
          that.userList = res.data
        } else {
          that.userList = []
        }
      })
    },
    submitForm() {
      let that = this
      if (typeof this.formData.xsc_user_id === 'undefined') {
        this.$message({type: 'error', message: '请选择原有人'})
        return
      }
      if (typeof this.formData.to_xsc_user_id === 'undefined') {
        this.$message({type: 'error', message: '请选择调整后人员'})
        return
      }
      this.$confirm('确认执行此操作吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 用户点击确定执行的逻辑
        Http.get("flow/FlowProcessSteps/batchEditStepsUser", this.formData,res=>{
          if(res.code) {
            this.$message({type: 'success', message: res.msg})
          } else {
            this.$message({type: 'error', message: res.msg})
          }
        })
        this.dialogVisible = false
      }).catch(() => {
        // 用户点击取消执行的逻辑
        this.$message({
          type: 'info',
          message: '已取消操作'
        });
      });

    },
    showBox() {
      this.formData = {}
      this.dialogVisible = true
    }
  }
}
</script>
<style lang="scss" scoped>

@import './common.scss';

.form-input {
  width: 300px;
}
.table-wrap{
  width: calc( 100vw - 120px - 200px );
  overflow-x: scroll;
}
.spacing {
  display: inline-block;
  margin-right: 10px;
  margin-top: 10px;
}
.el-row {
  margin-bottom: 10px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  //background: #99a9bf;
}
.bg-purple {
  //background: #d3dce6;
}
.bg-purple-light {
  //background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 80px;
}
.border {
  border: 1px solid #e8e8e8;
}
.row-bg {
  padding: 5px 0;
  background-color: #f9fafc;
}
.button-table {
  color: #1867c0;
  cursor: pointer;
  display: inline-block;
  margin-left: 15px
}

</style>



// WEBPACK FOOTER //
// src/components/Admin/Flow/FlowDeploy.vue